import { useService } from "../../../hooks";
import { useUnitGeneric } from "./useUnitGeneric";

export const useUnitPage = (passedUnitId?: number) => {
  const { getUnitForUnitPage } = useService();
  return useUnitGeneric(getUnitForUnitPage, passedUnitId);
};